<template>
  <div class="container-fluid py-4">

    <!-- Spinner de chargement -->
    <div v-if="isLoading" class="text-center my-5">
      <div class="spinner-border text-primary" role="status" style="width: 4rem; height: 4rem;">
        <span class="visually-hidden">Chargement...</span>
      </div>
      <p class="mt-2">Chargement du conditionnement...</p>
    </div>

    <!-- Formulaire -->
    <div v-else>
      <!-- Header moderne -->
      <div class="d-flex justify-content-between align-items-center mb-4 header-clinique">
        <div class="d-flex align-items-center gap-3">
          <i class="bi bi-box-seam fs-2 text-primary"></i>
          <h2 class="fw-bold mb-0">Modifier Conditionnement</h2>
        </div>
      </div>

      <div class="card p-4 shadow-sm rounded card-clinique">
        <div class="row g-3">
          <!-- Libellé -->
          <div class="col-md-6">
            <label for="nom" class="form-label fw-semibold">Libellé</label>
            <input 
              type="text" 
              id="nom" 
              v-model="form.nom" 
              class="form-control form-control-clinique" 
              placeholder="Ex: Boîte, Flacon, Sachet..."
            >
          </div>

          <!-- Switch Activé -->
          <div class="col-md-3 d-flex align-items-center">
            <div class="form-check form-switch mt-3">
              <input 
                class="form-check-input" 
                type="checkbox" 
                id="isEnabled" 
                v-model="form.isEnabled">
              <label class="form-check-label fw-semibold" for="isEnabled">Activé ?</label>
            </div>
          </div>
        </div>

        <!-- Boutons -->
        <div class="d-flex justify-content-end mt-4 gap-2">
          <button 
            class="btn btn-success btn-clinique" 
            :disabled="isSaving"
            @click="updateConditionnement">
            <span v-if="isSaving">
              <span class="spinner-border spinner-border-sm me-2" role="status"></span>
              Chargement...
            </span>
            <span v-else>Enregistrer</span>
          </button>
          <router-link to="/conditionnements" class="btn btn-clinique-outline">Annuler</router-link>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import api from '@/api';

export default {
  name: "EditConditionnement",
  data() {
    return {
      form: {
        nom: "",
        isEnabled: true,
      },
      isLoading: true,   // pour le chargement initial des données
      isSaving: false    // pour le bouton enregistrer
    };
  },
  mounted() {
    this.fetchConditionnement();
  },
  methods: {
    async fetchConditionnement() {
      const id = this.$route.params.id;
      this.isLoading = true;
      try {
        const response = await api.getItem('conditionnements', id);
        this.form = {
          nom: response.data.nom,
          isEnabled: response.data.isEnabled,
        };
      } catch (error) {
        console.error("Erreur lors de la récupération du conditionnement", error);
      } finally {
        this.isLoading = false;
      }
    },
    async updateConditionnement() {
      if (this.isSaving) return;
      this.isSaving = true;
      const id = this.$route.params.id;
      try {
        await api.patchItem('conditionnements', id, this.form);
        this.$router.push("/conditionnements");
      } catch (error) {
        console.error("Erreur lors de la mise à jour du conditionnement", error);
      } finally {
        this.isSaving = false;
      }
    }
  }
};
</script>

<style scoped>
/* Header */
.header-clinique {
  padding: 15px 20px;
  background-color: #e9f5ff;
  border-radius: 12px;
  margin-bottom: 20px;
}

/* Card */
.card-clinique {
  background: #f8fafd;
  border-radius: 12px;
  border: none;
}

/* Inputs */
.form-control-clinique {
  border-radius: 10px;
  border: 1px solid #d1e3f0;
  padding: 8px 12px;
  transition: all 0.3s ease;
}
.form-control-clinique:focus {
  box-shadow: 0 0 6px #0d6efd33;
  border-color: #0d6efd;
}

/* Boutons */
.btn-clinique {
  background: linear-gradient(90deg, #0d6efd, #6610f2);
  border: none;
  color: #fff;
  border-radius: 10px;
  padding: 8px 20px;
  transition: all 0.3s ease;
}
.btn-clinique:hover {
  box-shadow: 0 5px 15px rgba(0,0,0,0.2);
  transform: translateY(-2px);
}

/* Bouton Annuler */
.btn-clinique-outline {
  background: #fff;
  border: 1px solid #dc3545;
  color: #dc3545;
  border-radius: 10px;
  padding: 8px 20px;
  transition: all 0.3s ease;
}
.btn-clinique-outline:hover {
  background: #dc3545;
  color: #fff;
  box-shadow: 0 5px 15px rgba(0,0,0,0.2);
  transform: translateY(-2px);
}

/* Spinner centrée */
.text-center .spinner-border {
  width: 4rem;
  height: 4rem;
}
</style>
